import "./industries.css";
import SEO from "../../SEO";
import NeuralNetCanvas from "../../components/NeuralNetCanvas";

/* ── SVG Icons ──────────────────────────────────────────────────────────── */
const BotIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="3" y="11" width="18" height="10" rx="2" />
    <circle cx="12" cy="5" r="2" />
    <line x1="12" y1="7" x2="12" y2="11" />
    <line x1="8" y1="15" x2="8" y2="15" strokeWidth="2.5" />
    <line x1="16" y1="15" x2="16" y2="15" strokeWidth="2.5" />
    <path d="M6 11V9a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2" />
  </svg>
);

const DatabaseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <ellipse cx="12" cy="5" rx="9" ry="3" />
    <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
    <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
  </svg>
);

const GearIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="3" />
    <path d="M19.07 4.93a10 10 0 1 0 0 14.14" />
    <path d="M12 1v3M12 20v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M1 12h3M20 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12" />
  </svg>
);

const CodeIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="16 18 22 12 16 6" />
    <polyline points="8 6 2 12 8 18" />
  </svg>
);

const FileAIIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);


const SearchIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);


const ClockIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const UserIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const TrendIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
    <polyline points="17 6 23 6 23 12" />
  </svg>
);

const CheckIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const ArrowIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

/* ── Data ───────────────────────────────────────────────────────────────── */
const solutions = [
  {
    icon: <BotIcon />,
    title: "AI Chatbots & Assistants",
    desc: "Conversational AI agents that resolve queries, handle workflows, and maintain context across sessions — deployed on web, mobile, and enterprise channels.",
  },
  {
    icon: <DatabaseIcon />,
    title: "RAG-Based Knowledge Systems",
    desc: "Retrieval-Augmented Generation pipelines that ground LLM answers in your private documents, databases, and knowledge bases — for accurate, cited responses.",
  },
  {
    icon: <GearIcon />,
    title: "AI Automation Platforms",
    desc: "Multi-agent workflow orchestration using LangGraph — automating complex business processes with stateful AI decision-making and human-in-the-loop controls.",
  },
  {
    icon: <CodeIcon />,
    title: "Code Generation Tools",
    desc: "Domain-aware AI coding assistants that generate, review, and refactor code aligned to your architecture standards, dramatically accelerating every sprint.",
  },
  {
    icon: <FileAIIcon />,
    title: "Document Intelligence Systems",
    desc: "Intelligent extraction and analysis across unstructured documents — contracts, invoices, reports, and manuals — delivering structured data at enterprise scale.",
  },
];


const projects = [
  {
    icon: <BotIcon />,
    tag: "NLP · Support",
    variant: "ai-proj--a",
    title: "AI Customer Support Bot",
    desc: "Handles tier-1 support queries instantly using a RAG pipeline over the company's knowledge base — with escalation to human agents when confidence is low.",
    features: [
      "RAG over company knowledge base",
      "Multi-turn conversation memory",
      "Smart escalation & handoff",
    ],
  },
  {
    icon: <FileAIIcon />,
    tag: "Document · Intelligence",
    variant: "ai-proj--b",
    title: "Document AI System",
    desc: "Upload any PDF, CSV, or report and get structured data extraction, intelligent Q&A, risk flagging, and summary outputs — powered by GPT-4 and LangChain.",
    features: [
      "Multi-format ingestion (PDF/CSV/DOCX)",
      "Structured extraction + Q&A",
      "Risk flags & auto-summary",
    ],
  },
  {
    icon: <CodeIcon />,
    tag: "Dev Tools · LLM",
    variant: "ai-proj--c",
    title: "AI Code Generator",
    desc: "A developer-focused AI tool that understands your codebase conventions and generates, explains, tests, and refactors code to your project's exact standards.",
    features: [
      "Codebase-aware generation",
      "Unit test auto-generation",
      "Inline refactor suggestions",
    ],
  },
  {
    icon: <SearchIcon />,
    tag: "Search · Semantic",
    variant: "ai-proj--d",
    title: "Semantic Search Engine",
    desc: "Vector-based search that understands user intent and semantic meaning — not just keywords — across any corpus of documents, products, or knowledge content.",
    features: [
      "Vector embedding + similarity search",
      "Query intent understanding",
      "Multi-corpus cross-search",
    ],
  },
];

const benefits = [
  {
    icon: <GearIcon />,
    title: "Automation of Complex Tasks",
    desc: "Multi-agent AI systems take over repetitive, time-consuming processes — approval chains, data extraction, report generation — freeing teams for strategic work.",
  },
  {
    icon: <ClockIcon />,
    title: "Faster Decision-Making",
    desc: "Real-time AI reasoning surfaces relevant data, patterns, and recommendations at the moment of decision — collapsing analysis cycles from hours to seconds.",
  },
  {
    icon: <UserIcon />,
    title: "Improved User Experience",
    desc: "Conversational interfaces and personalised AI responses create intuitive, fast interactions that users actually prefer over traditional form-based workflows.",
  },
  {
    icon: <TrendIcon />,
    title: "Scalable AI Systems",
    desc: "Serverless, API-first architectures mean your AI systems scale from 10 users to 10 million — without re-engineering the core model or pipeline.",
  },
];

/* ── Component ──────────────────────────────────────────────────────────── */
export default function AIProducts() {
  return (
    <>
      <SEO
        title="AI Products: Automation Tools & Business AI | Best Code Technology"
        description="Explore AI-powered products for automation and business growth."
        keywords="AI products, automation tools, AI solutions"
        url="https://bestcodetechnology.in/industries/ai-products"
      />

      <div className="ind-page">
        {/* ════════════════════════════════════════════════════════════════════
          HERO — deep dark split: left content + right neural-net placeholder
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="ai-hero">
          <NeuralNetCanvas />
          <div className="container-xl">
            <div className="row align-items-center g-5">
              {/* Left: Content */}
              <div className="col-12 col-lg-6">
                <div className="ai-hero__eyebrow">
                  <span className="ai-pill">AI Products</span>
                </div>

                <h1 className="ai-hero__headline">
                  Next-Generation
                  <span> AI Solutions</span> for Every Industry
                </h1>

                <p className="ai-hero__desc">
                  We specialise in building AI-powered products that solve
                  complex business problems and unlock new opportunities — from
                  RAG systems and autonomous agents to intelligent automation
                  platforms.
                </p>

                <div className="ai-hero__actions">
                  <a href="#solutions" className="ai-btn-primary">
                    Explore Solutions
                    <ArrowIcon />
                  </a>
                  <a href="#projects" className="ai-btn-ghost">
                    See What We Build
                  </a>
                </div>

                <div className="ai-hero__stats">
                  <div className="ai-stat">
                    <span className="ai-stat__value">LLM-Native</span>
                    <span className="ai-stat__label">Architecture</span>
                  </div>
                  <div className="ai-stat__sep" aria-hidden="true" />
                  <div className="ai-stat">
                    <span className="ai-stat__value">RAG + Agents</span>
                    <span className="ai-stat__label">Core Stack</span>
                  </div>
                  <div className="ai-stat__sep" aria-hidden="true" />
                  <div className="ai-stat">
                    <span className="ai-stat__value">Production</span>
                    <span className="ai-stat__label">Ready Systems</span>
                  </div>
                  <div className="ai-stat__sep" aria-hidden="true" />
                  <div className="ai-stat">
                    <span className="ai-stat__value">GPT-4 / Claude</span>
                    <span className="ai-stat__label">Powered</span>
                  </div>
                </div>
              </div>

              {/* Right: live inference view */}
              <div className="col-12 col-lg-6">
                <div className="ai-hero__visual">
                  <div className="ai-dashboard">
                    <div className="ai-dashboard__head">
                      <span className="ai-dashboard__title">
                        <span className="ai-dashboard__dot" aria-hidden="true" />
                        Agent Session
                      </span>
                      <span className="ai-dashboard__live">THINKING</span>
                    </div>

                    {/* Prompt → the user turn */}
                    <div className="ai-turn ai-turn--user">
                      <span className="ai-turn__role">Prompt</span>
                      <p className="ai-turn__text">
                        Summarise Q3 contract risk across all vendor
                        agreements.
                      </p>
                    </div>

                    {/* Reasoning trace — what an agent actually does */}
                    <div className="ai-trace">
                      <span className="ai-trace__label">Reasoning trace</span>
                      <ul className="ai-trace__steps">
                        <li className="ai-trace__step ai-trace__step--1">
                          <span className="ai-trace__tick" aria-hidden="true" />
                          <span className="ai-trace__text">
                            Retrieved <strong>42</strong> contract chunks
                          </span>
                        </li>
                        <li className="ai-trace__step ai-trace__step--2">
                          <span className="ai-trace__tick" aria-hidden="true" />
                          <span className="ai-trace__text">
                            Ranked by clause relevance
                          </span>
                        </li>
                        <li className="ai-trace__step ai-trace__step--3">
                          <span className="ai-trace__tick" aria-hidden="true" />
                          <span className="ai-trace__text">
                            Called <strong>risk_scorer</strong> tool
                          </span>
                        </li>
                        <li className="ai-trace__step ai-trace__step--4">
                          <span className="ai-trace__tick ai-trace__tick--active" aria-hidden="true" />
                          <span className="ai-trace__text">
                            Generating grounded answer
                          </span>
                        </li>
                      </ul>
                    </div>

                    {/* Streaming response */}
                    <div className="ai-turn ai-turn--model">
                      <span className="ai-turn__role ai-turn__role--model">
                        Response
                      </span>
                      <div className="ai-stream__lines" aria-hidden="true">
                        <span className="ai-stream__line ai-stream__line--1" />
                        <span className="ai-stream__line ai-stream__line--2" />
                        <span className="ai-stream__line ai-stream__line--3" />
                        <span className="ai-stream__caret" />
                      </div>
                      <div className="ai-cites">
                        <span className="ai-cite">MSA-2024.pdf</span>
                        <span className="ai-cite">vendor-terms.docx</span>
                        <span className="ai-cite">+4</span>
                      </div>
                    </div>

                    {/* Runtime footer */}
                    <div className="ai-runtime">
                      <span className="ai-runtime__item">
                        <span className="ai-runtime__value">1,284</span>
                        <span className="ai-runtime__label">tokens</span>
                      </span>
                      <span className="ai-runtime__item">
                        <span className="ai-runtime__value">6</span>
                        <span className="ai-runtime__label">sources</span>
                      </span>
                      <span className="ai-runtime__item">
                        <span className="ai-runtime__value ai-runtime__value--ok">
                          passed
                        </span>
                        <span className="ai-runtime__label">guardrails</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ════════════════════════════════════════════════════════════════════
          SOLUTIONS — split-body cards (dark icon zone + light content)
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="ai-solutions" id="solutions">
          <div className="container-xl">
            <div className="row justify-content-center mb-4 mb-lg-5">
              <div className="col-12 col-md-10 col-lg-7 text-center">
                <span className="ai-pill ai-pill--subtle">Key Solutions</span>
                <h2 className="ai-section-title mt-3">
                  AI Products Built for Real Business Impact
                </h2>
                <p className="ai-section-sub">
                  Five core AI product lines — each a production-grade system
                  built on LLMs, vector search, and agent orchestration
                  frameworks.
                </p>
              </div>
            </div>

            <div className="row g-4">
              {solutions.map((item, i) => (
                <div
                  key={i}
                  className={`col-12 col-md-6 ${i < 3 ? "col-lg-4" : "col-lg-6"}`}
                >
                  <div className="ai-sol-card">
                    {/* Left: dark icon + number zone */}
                    <div className="ai-sol-card__aside">
                      <div className="ai-sol-card__icon">{item.icon}</div>
                    </div>
                    {/* Right: content */}
                    <div className="ai-sol-card__content">
                      <h4 className="ai-sol-card__title">{item.title}</h4>
                      <p className="ai-sol-card__desc">{item.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>


        {/* ════════════════════════════════════════════════════════════════════
          PROJECTS — 2×2 gradient background cards (4 projects)
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="ai-projects" id="projects">
          <div className="container-xl">
            <div className="row justify-content-center mb-4 mb-lg-5">
              <div className="col-12 col-md-10 col-lg-7 text-center">
                <span className="ai-pill ai-pill--glow">Platform Capabilities</span>
                <h2 className="ai-section-title ai-section-title--light mt-3">
                  What We Build with AI
                </h2>
                <p className="ai-section-sub ai-section-sub--light">
                  Four AI platform builds we take on — spanning assistants,
                  document intelligence, code generation, and semantic search.
                </p>
              </div>
            </div>

            <div className="row g-4">
              {projects.map((project, i) => (
                <div key={i} className="col-12 col-lg-6">
                  <div className={`ai-proj-card ${project.variant}`}>
                    <div className="ai-proj-card__header">
                      <div className="ai-proj-card__icon">{project.icon}</div>
                      {/* */}
                    </div>
                    <span className="ai-proj-card__tag">{project.tag}</span>
                    <h3 className="ai-proj-card__title">{project.title}</h3>
                    <p className="ai-proj-card__desc">{project.desc}</p>
                    <ul className="ai-proj-card__features">
                      {project.features.map((feat, fi) => (
                        <li key={fi}>
                          <CheckIcon />
                          <span>{feat}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ════════════════════════════════════════════════════════════════════
          BENEFITS — light bg, 2×2 outlined-circle number cards
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="ai-benefits">
          <div className="container-xl">
            <div className="row justify-content-center mb-4 mb-lg-5">
              <div className="col-12 col-md-10 col-lg-7 text-center">
                <span className="ai-pill ai-pill--subtle">Why BCT</span>
                <h2 className="ai-section-title mt-3">
                  The Advantage of Building with BCT
                </h2>
                <p className="ai-section-sub">
                  From LLM architecture to production deployment, every AI
                  product we ship is engineered for reliability, accuracy, and
                  scale.
                </p>
              </div>
            </div>

            <div className="row g-4">
              {benefits.map((b, i) => (
                <div key={i} className="col-12 col-sm-6">
                  <div className="ai-benefit-card">
                    <div className="ai-benefit-card__top">
                      <div className="ai-benefit-card__icon">{b.icon}</div>
                    </div>
                    <h4 className="ai-benefit-card__title">{b.title}</h4>
                    <p className="ai-benefit-card__desc">{b.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA strip */}
            <div className="ai-cta-strip">
              <div className="row align-items-center">
                <div className="col-12 col-lg-8">
                  <h3 className="ai-cta-strip__title">
                    Ready to build your next AI-powered product?
                  </h3>
                  <p className="ai-cta-strip__sub">
                    From LLM prototypes to production-grade AI systems — let's
                    build it together.
                  </p>
                </div>
                <div className="col-12 col-lg-4 text-lg-end">
                  <a
                    href="/services/ai-applications"
                    className="ai-btn-primary"
                  >
                    Start a Project
                    <ArrowIcon />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
